import React from 'react';
import { Grid, Tooltip } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { goto } from 'utils';

interface Props {
  title: string;
  value: number | string;
  icon?: any;
  backColor?: string;
  // Forecolor of widget text
  color?: string;
  // click on widget pushes this url to history (redirects user to the url)
  to?: string;
  titleFontSize?: string;
  description?: string
}

const StatsWidget: React.FC<Props> = (props) => {
  const {
    title,
    value = 0,
    icon,
    backColor,
    color,
    to,
    titleFontSize,
    description,
  } = props;

  const history = useHistory();

  return (
    <Tooltip
      title={String(description)}
      arrow={true}
    >
      <div
        className="statswidget-container"
        // style={{
        //   backgroundColor: backColor,
        //   color: color,
        // }}
        style={{
          background: '#FFFFFD',
          borderBottom: '5px solid #21AD72',
          boxShadow: '0px 0px 8px 2px rgba(0, 0, 0, 0.15)',
          borderRadius: '15px'
        }}
        onClick={(e: any): void => {
          e.preventDefault()
          goto(history, to, true)
        }}
      >
        <Grid container className="statswidget-grid-container">
          <Grid item container className="statswidget-content statswidget-grid-container" xs={12} style={{ padding: '10' }}>
            <Grid item className="statswidget-value" xs={4} style={{ lineHeight: '100px', marginLeft: '10px', textAlign: 'center' }}>
              <span style={{ fontSize: '40px', fontWeight: 700, background: '#EEEEEE', color: '#3D2294', width: 25, textAlign: 'center', padding: '0px 20px', borderRadius: '10px' }}>
                {value != '' && value}
                {value == '' && <>&nbsp;</>}
              </span>
            </Grid>
            <Grid item className="statswidget-title" xs={6}
              style={{
                marginLeft: '5px', whiteSpace: 'nowrap', color: '#5B5B5B', fontStyle: 'normal', fontWeight: 700, fontSize: '13px', lineHeight: '100px', textAlign: 'center'
              }}>
              {title}
            </Grid>
          </Grid>
          {/* {icon &&
            <Grid item className="statswidget-icon" xs={4}>
              {icon}
            </Grid>
          } */}
        </Grid>
      </div>
    </Tooltip>
  )
}

export default StatsWidget;
